export default __webpack_public_path__ + "static/media/p6.cda45cfe.PNG";